module.exports = __webpack_public_path__ + "6ee0a808f4af84a11fa84f3f5291215d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-koreha-yabai.png
// module id = 2084
// module chunks = 4